export default __webpack_public_path__ + "static/media/mimgEvent-min.7f7168f8.jpg";